/* import __COLOCATED_TEMPLATE__ from './blade.hbs'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
import { BalanceReportItemDetail } from '@square/dashboard-protos/models/squareup/balancereporter/model';
export default class Blade extends Component {
  constructor(...args) {
    super(...args);
    // "static" properties
    _defineProperty(this, "DisplayPosition", BalanceReportItemDetail.Banner.DisplayPosition);
    _defineProperty(this, "showDisputeFormModal", false);
  }
  get bladeClassName() {
    return this.args.loadingDetails ? 'banking-activity-blade__loading-wrapper banking-activity-blade' : 'banking-activity-blade';
  }
  willDestroy() {
    super.willDestroy();
    this.args.onDestroyBlade();
  }
}